<template>
  <div>
    <div>
         <canvas id='student_map_canvas'></canvas>
    </div>
    </div>
  </div>
</template>

<script>
import Vue from 'vue';
import Chartkick from 'vue-chartkick';
import * as ChartGeo from 'chartjs-chart-geo'
import Chart from 'chart.js';
import UserClient from '@/api/UserClient';
import AdminClient from '@/api/AdminClient';
import us from "./states-10m.json"

Vue.use(Chartkick.use(Chart));

export default {
    name: 'StudentsByState',
    data() {
        return {
        adminClient: new AdminClient(this.$http),
        chart:null
        }
    },
    async mounted() {
      this.mapBuild();
        },
      methods: {
        mapBuild() {
                  let canvas = document.getElementById("student_map_canvas")
                  if(!canvas) return

          

                      const nation = ChartGeo.topojson.feature(us, us.objects.nation).features[0];
                      const states = ChartGeo.topojson.feature(us, us.objects.states).features;
                      this.adminClient.getStudentByState().then((res) => {
                      const mapData = res.results

                    states.forEach((s) => {
                     s.students = mapData.filter(each => each.state === s.properties.name)
                      })


                      this.chart = new Chart(canvas.getContext("2d"), {
                        type: 'choropleth',
                        data: {
                          labels: states.map(d =>  d.properties.name + "  Total Students"),
                          datasets: [{
                            label: 'States',
                            outline: nation,
                            data: states.map((d) => ({feature: d, value: d.students.length ? d.students[0].total : 0 })),
                          
                          }]
                        },
                        options: {
                          legend: {
                            display: false
                          },
                          scale: {
                            projection: 'albersUsa'
                          },
                          geo: {
                            colorScale: {
                              display: true,
                              position: 'bottom',
                              quantize: 5,
                              legend: {
                                position: 'bottom-right',
                              },
                            },
                          },
                        }
                      });
                    });
                    
              },
          }
}
</script>
